import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type VendorEmailRequestsInChat = {
  id: string;
  name: string;
  email: string;
  logo_url: string;
};

const initialState = {
  vendorEmailRequestsInChat: [] as VendorEmailRequestsInChat[],
  entityId: "",
  season: "",
};

export const vendorEmailRequestsInChat = createSlice({
  name: "vendorEmailRequestsInChat",
  initialState,
  reducers: {
    setVendorEmailRequestsInChat: (
      state,
      action: PayloadAction<typeof initialState>
    ) => {
      state.vendorEmailRequestsInChat =
        action.payload.vendorEmailRequestsInChat;
      state.entityId = action.payload.entityId;
      state.season = action.payload.season;
    },
    clearVendorEmailRequestsInChat: (state) => {
      state.vendorEmailRequestsInChat = [];
      state.entityId = "";
      state.season = "";
    },
  },
});

export const { setVendorEmailRequestsInChat, clearVendorEmailRequestsInChat } =
  vendorEmailRequestsInChat.actions;
export default vendorEmailRequestsInChat.reducer;
